import { SIGNEDIN_VIA_HORIZONTAL_COOKIE } from '@move-auth/shared';

import getCookie from './getCookie';

const setCookie = (name, value) => {
  document.cookie = `${name}=${value}; path=/; SameSite=Lax; secure`;
};

export const noop = () => {};

export const setSignedInViaHorizontal = () =>
  setCookie(SIGNEDIN_VIA_HORIZONTAL_COOKIE, 1);

export const wasSignedInViaHorizontal = () =>
  Boolean(getCookie(SIGNEDIN_VIA_HORIZONTAL_COOKIE));
